import React from "react";
import {
	List,
	Datagrid,
	TextField,
	ReferenceField,
	EditButton,
	ShowButton,
	SelectInput,
	Filter,
	SelectField,
	ReferenceArrayInput,
	SelectArrayInput,
	DateField,
	ChipField,
	TextInput
} from "react-admin";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import { SUPERADMIN } from "../../constant/TypeRole";
import { typePaymentInvoice } from "../../constant/TypePaymentInvoice";
import Actions from "../Actions";
import moment from "moment";

const PaymentInvoiceFilter = props => {
	const role = localStorage.getItem("role");
	const project = JSON.parse(localStorage.getItem("project"));
	const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
	return (
		<Filter {...props}>
			<SelectInput source="type" choices={typePaymentInvoice} />
			<TextInput alwaysOn source="ticket_no_contains" />
			<ReferenceArrayInput
				alwaysOn
				style={{ minWidth: "200px" }}
				source="project"
				reference="project"
				filter={filter}
			>
				<SelectArrayInput optionText="name" />
			</ReferenceArrayInput>
		</Filter>
	);
};

const exporter = (records, fetchRelatedRecords) => {
	Promise.all(records.map(async (record) => {
		let newRecord = {};
		let repairStatus = typePaymentInvoice.find(x => x.id === record.type).name;
		await fetchRelatedRecords(records, "project", "project").then(res => { newRecord = { ...newRecord, project: res[record.project].name }; });
		// await fetchRelatedRecords(records, "type", "repairtype").then(res => { newRecord = { ...newRecord, type: res[record.type].name }; });
		await fetchRelatedRecords(records, "user", "user").then(res => { newRecord = { ...newRecord, user: res[record.user].email }; });
		await fetchRelatedRecords(records, "room", "room").then(res => { newRecord = { ...newRecord, room: res[record.room].name }; });
		return {
			...newRecord,
			ticket_no: record.ticket_no,
			description: record.description,
			type: repairStatus,
			createdAt: moment(record.createdAt).format("YYYY-MM-DD HH:mm:ss")
		};
	})).then(data => {
		const csv = convertToCSV({
			data,
			fields: ["ticket_no", "type", "description", "user", "room", "project", "createdAt"] // order fields in the export
		});
		csvDownload(csv, "paymentinvoice");
	});
};

const csvDownload = (csv, filename) => {
	const fakeLink = document.createElement("a");
	fakeLink.style.display = "none";
	document.body.appendChild(fakeLink);
	const blob = new Blob(["\uFEFF" + csv], { type: "text/csv" });
	if (window.navigator && window.navigator.msSaveOrOpenBlob) {
		// Manage IE11+ & Edge
		window.navigator.msSaveOrOpenBlob(blob, `${filename}.csv`);
	} else {
		fakeLink.setAttribute("href", URL.createObjectURL(blob));
		fakeLink.setAttribute("download", `${filename}.csv`);
		fakeLink.click();
	}
};

export const PaymentInvoiceList = props => {
	const role = localStorage.getItem("role");
	const project = JSON.parse(localStorage.getItem("project"));
	const filter = role ? (role === SUPERADMIN ? {} : { project }) : { project };
	return (
		<List
			{...props}
			title="paymentinvoice.paymentinvoice"
			bulkActions={false}
			filters={<PaymentInvoiceFilter />}
			sort={{ field: "createdAt", order: "DESC" }}
			filterDefaultValues={filter}
			actions={<Actions isExport />}
			exporter={exporter}
		>
			<Datagrid>
				<div />
				<TextField source="ticket_no" />
				<ReferenceField linkType={false} source="room" reference="room">
					<TextField source="name" />
				</ReferenceField>
				<SelectField
					source="type"
					optionText={<ChipField source="name" />}
					choices={typePaymentInvoice}
				/>
				<ReferenceField linkType={false} source="project" reference="project">
					<ChipField source="name" />
				</ReferenceField>
				<DateField
					source="createdAt"
					locales="th-TH"
					options={{
						day: "numeric",
						month: "short",
						year: "numeric",
						hour: "numeric",
						minute: "numeric"
					}}
				/>
				<EditButton />
			</Datagrid>
		</List>
	);
};



// WEBPACK FOOTER //
// ./src/components/paymentinvoice/PaymentInvoiceList.js